import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, ProjectConfiguration } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  config: ProjectConfiguration;
  retrieveProjectToolsConfiguration(
    data: Boundaries["retrieveProjectToolsConfiguration"]["request"],
  ): void;
}

function useRetrieveProjectToolsConfiguration(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectToolsConfigurationRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectToolsConfigurationRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectToolsConfigurationRequestFailure(project),
    ),
    config: useSelector(() => selector.getProjectToolsConfiguration(project)),
    retrieveProjectToolsConfiguration: core.retrieveProjectToolsConfiguration,
  };
}

export { useRetrieveProjectToolsConfiguration };
